module.exports = __webpack_public_path__ + "static/img/personal_banner_QR.d9b5288.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/geren/personal_banner_QR.png
// module id = ci32
// module chunks = 1